import React from 'react';
import * as myConstClass from '../../../shared/constants/constants';
import { HANDICAPTYPE } from "../../../shared/constants/constants";

class Scoreboard_8B extends React.Component {

  constructor(props) {
		super(props);
		this.createRoundRow = this.createRoundRow.bind(this);
	}

	render() {
		//console.log('Scoreboard_8B: RENDER')
		return (
	 		<div className="table-responsive">
				<h3>Sommaire</h3>
				<table className="table">
		 			{this.dispRoundBody()}
		 			{this.dispSummaryBody()}
				</table>
			</div>
		);
	}

 	dispRoundBody() {
	 	// Only in Leagues
		if(this.props.resultsType === myConstClass.RESTYPE_LEAGUE) {
			return (
				<tbody>
					<tr className="boldrow">
						<td><strong> RONDES </strong></td>
						<td><strong> Local </strong></td>
						<td><strong> Visiteur </strong></td>
					</tr>

					{this.props.rounds.map(this.createRoundRow)}
					{this.createRowTotalMatch()}
					{this.createRowTotalRondes()}

					<tr><td>&nbsp;</td><td></td><td></td></tr>
				</tbody>
	 		);
		}
	}

	dispSummaryBody() {
		return (
			<tbody>
				<tr><td><strong>TOTAUX</strong></td><td></td><td></td></tr>
			 	{this.dispSubtotal()}
			 	{this.dispHandicap()}
			 	{this.dispTotal()}
			 	{this.dispWins()}
			 	{this.dispERO()}
			 	{this.dispTV()}
			 	{this.dispPointDeVictoireTournoi()}
		 	</tbody>
 		);
	}

	createRoundRow(round) {
		var description = round.description;
		var roundPts1 = round.team1Pts;
		var roundPts2 = round.team2Pts;

		if (this.props.formatMatchType === "ROUND POINTS") {
			roundPts1 +=  " · " + round.team1RoundPts;
			roundPts2 +=  " · " + round.team2RoundPts;
		}

		return (
			<tr key={round.roundNumber}>
				<td>{description}</td>
				<td>{roundPts1}</td>
				<td>{roundPts2}</td>
			</tr>
		);
	}

	createRowTotalMatch() {
		if (this.props.handicapType !== "Moy-500") {
			var totalPts1 = this.props.team1TotalPts;
			var totalPts2 = this.props.team2TotalPts;
			
			if ((this.props.formatMatchType === "ROUND POINTS") && 
				 ((this.props.formatMatchPoint === "MATCH POINT (POINTS)") || (this.props.formatMatchPoint === "HALF MATCH POINTS"))) {
				totalPts1 +=  " · " + this.props.team1MatchPts;
				totalPts2 +=  " · " + this.props.team2MatchPts;
			}

			return (
				<tr>
					<td>Total - Match</td>
					<td>{totalPts1}</td>
					<td>{totalPts2}</td>
				</tr>
			);
		}
	}

	createRowTotalRondes() {
		if (this.props.formatMatchType === "ROUND POINTS") {
			return (
				<tr className="boldrow">
					<td>Total - Rondes</td>
				 	<td>{this.props.team1TotalRoundPts}</td>
					<td>{this.props.team2TotalRoundPts}</td>
				</tr>
			);
		}
	}

	dispSubtotal() {
		if (this.props.handicapType === HANDICAPTYPE.MOY500) {
			return (
			 	<tr>
				 	<td>Sous-total</td>
				 	<td>{Math.round((this.props.team1TotalPts - this.props.team1HandicapPts) * 100) / 100}</td>
				 	<td>{Math.round((this.props.team2TotalPts - this.props.team2HandicapPts) * 100) / 100}</td>
			 	</tr>
			)
		}
	}

	dispHandicap() {
		if (this.props.handicapType === HANDICAPTYPE.MOY500) {
			return (
				<tr>
					<td>Handicap</td>
					<td>{this.props.team1HandicapPts}</td>
					<td>{this.props.team2HandicapPts}</td>
				</tr>
			)
		}
	}

	dispTotal() {
		return (
		 	<tr>
			 	<td>Total</td>
			 	<td>{this.props.team1TotalPts}</td>
			 	<td>{this.props.team2TotalPts}</td>
		 	</tr>
		)
	}

	dispWins() {
		return (
			<tr>
				<td>Victoires</td>
				<td>{this.props.team1TotalWins}</td>
				<td>{this.props.team2TotalWins}</td>
			</tr>
		)
	}

	dispERO() {
		return (
		 	<tr>
			 	<td>ERO</td>
			 	<td>{this.props.team1TotalEro}</td>
			 	<td>{this.props.team2TotalEro}</td>
		 	</tr>
		)
	}
	
	dispTV() {
		// ONLY FOR QVNEA
		if (this.props.stateloLeagueParam.includes('QVNEA')) {
			return (
				<tr>
					<td>TV (tables vidées)</td>
					<td>{this.props.team1TotalTv}</td>
					<td>{this.props.team2TotalTv}</td>
				</tr>
			);
		}
	}

	dispPointDeVictoireTournoi() {
		// Tournaments
		if (this.props.resultsType === myConstClass.RESTYPE_TOURNAMENT) {

	 		var winPtTeam1 = 0.5;
	 		var winPtTeam2 = 0.5;
	 		if(this.props.team1TotalPts > this.props.team2TotalPts) {
				winPtTeam1 = 1;
				winPtTeam2 = 0;
	 		} else if (this.props.team1TotalPts < this.props.team2TotalPts) {
				winPtTeam1 = 0;
				winPtTeam2 = 1;
	 		}

			return (
			 	<tr>
				 	<td>Point de victoire</td>
				 	<td>{winPtTeam1}</td>
				 	<td>{winPtTeam2}</td>
				</tr>
			);
		}
	}

}

export default Scoreboard_8B;